export type SurveysFeatureProperties = {
  _version: undefined | 1;
  type: string;
};

export enum SurveyTypeEnum {
  TenantAdminSatisfaction = 'tenantAdminSatisfaction',
}
